import {
  Box,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Divider,
  HStack,
  VStack,
  Text,
  IconButton,
  DrawerOverlay,
  Center,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  FormControl,
  FormLabel,
  Input,
  Badge,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { FiEye } from "react-icons/fi";

interface ApprovalRequestProps {
  isOpen: boolean;
  onClose: () => void;
  submitRequest: (file: any) => void;
  request?: any;
}
const ApprovalRequestModal = ({
  isOpen,
  onClose,
  submitRequest,
  request,
}: ApprovalRequestProps) => {
  const [closeDrawerLoading, setCloseDrawerLoading] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [file, setFile] = useState<File | null>(null);
  const [fileName, setFileName] = useState("");

  const baseUrl =
    process.env.REACT_APP_BASE_URL || "http://196.188.175.178:8008";
  const status = request?.status;

  const openDocument = () => {
    setIsDrawerOpen(true);
  };
  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
  };

  const getModalTitle = () => {
    let toDisplayTitle = null;
    let toDisplayMessage = null;

    switch (status) {
      case "Pending":
        toDisplayTitle = `Review Current Request`;
        toDisplayMessage = `This is your current pending approval request`;
        break;
      case "Rejected":
        toDisplayTitle = `Approval Request Rejected.`;
        toDisplayMessage = `Your approval request has been rejected.`;
        break;
      default:
        toDisplayTitle = null;
    }
    return {
      toDisplayTitle: toDisplayTitle,
      toDisplayMessage: toDisplayMessage,
    };
  };

  useEffect(() => {
   console.log("Request: ", request);
   

  },[]);
  return (
    <Box
      display={"flex"}
      h={"100%"}
      w={"100%"}
      flexDirection={"column"}
      justifyContent={"flex-start"}
      alignContent={"flex-start"}
      alignItems={"flex-start"}
      textAlign={"left"}
    >
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{getModalTitle().toDisplayTitle}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack align={"flex-start"}>
              <Text fontSize="sm" fontWeight="bold" textAlign="center">
                {getModalTitle().toDisplayMessage}
              </Text>
              <Divider borderColor="gray.300" />
              <VStack
                justifyItems={"flex-start"}
                alignContent={"flex-start"}
                alignItems={"flex-start"}
                borderBottomWidth={1}
                pb={2}
                w={"100%"}
              >
                <Text fontSize="md" fontWeight="bold" textAlign="left">
                  Requested at
                </Text>
                <Text fontSize="lg" fontWeight="normal" textAlign="center">
                  {request?.created_at.split("T")[0]}
                </Text>
              </VStack>
              <VStack
                justifyItems={"flex-start"}
                alignContent={"flex-start"}
                alignItems={"flex-start"}
                borderBottomWidth={1}
                pb={2}
                w={"100%"}
              >
                <Text fontSize="md" fontWeight="bold" textAlign="left">
                  Status
                </Text>
                <Badge fontSize="0.8em" colorScheme="green" p={1}>
                  {request?.status}
                </Badge>
                {/* <Text
                  fontSize="sm"
                  fontWeight="bold"
                  textAlign="center"
                  mb={4}
                ></Text> */}
              </VStack>
              <VStack
                justifyItems={"flex-start"}
                alignContent={"flex-start"}
                alignItems={"flex-start"}
                borderBottomWidth={1}
                pb={2}
                w={"100%"}
              >
                <Text fontSize="md" fontWeight="bold" textAlign="left">
                  Description
                </Text>
                <Text fontSize="md" fontWeight="normal" textAlign="center">
                  {request?.comment}
                </Text>
              </VStack>
              <VStack w={"100%"} pt={4}>
                <Button
                  colorScheme="blue"
                  w={"100%"}
                  variant={"outline"}
                  mr={3}
                  onClick={() => openDocument()}
                >
                  View Document
                </Button>
              </VStack>
              {status == "Rejected" && (
                <HStack>
                  <Text
                    fontSize="sm"
                    fontWeight="bold"
                    textAlign="center"
                    mb={4}
                  >
                    Rejection Reason :
                  </Text>
                  <Text
                    fontSize="sm"
                    fontWeight="bold"
                    textAlign="center"
                    mb={4}
                  >
                    {request?.reason}
                  </Text>
                </HStack>
              )}
              {status == "Rejected" && request.reason == "Invalid Document" && (
                <FormControl marginTop={4}>
                  <FormLabel htmlFor="adminDocument" display="flex">
                    Upload approval letter (PDF only)
                    <Text color="red" mx={1} fontSize={24}>
                      *
                    </Text>
                  </FormLabel>
                  <Box
                    border="1px solid"
                    borderColor="gray.300"
                    borderRadius="md"
                    padding={2}
                    _hover={{ borderColor: "gray.500" }}
                  >
                    <Input
                      id="adminDocument"
                      name="adminDocument"
                      type="file"
                      accept="application/pdf"
                      onChange={(event) => {
                        const file = event?.target.files?.[0]?.name || "";
                        setFile(event?.target.files?.[0] || null);
                        setFileName(file);
                      }}
                      style={{ display: "none" }}
                    />
                    <Box
                      as="label"
                      htmlFor="adminDocument"
                      cursor="pointer"
                      display="block"
                      textAlign="center"
                      padding={2}
                      backgroundColor="gray.100"
                      borderRadius="md"
                      _hover={{ backgroundColor: "gray.200" }}
                    >
                      Choose Document
                    </Box>
                    {fileName && (
                      <Text mt={2} fontSize="sm" color={"green"}>
                        {fileName}
                      </Text>
                    )}
                  </Box>
                </FormControl>
              )}
            </VStack>
          </ModalBody>
          <ModalFooter>
            {status == "Rejected" && request.reason == "Invalid Document" && (
              <Button
                colorScheme="blue"
                isLoading={closeDrawerLoading}
                mr={3}
                onClick={async () => {
                  setCloseDrawerLoading(true);
                  setTimeout(() => {
                    submitRequest(file);
                    onClose();
                    setCloseDrawerLoading(false);
                  }, 2000);
                }}
              >
                Request Again
              </Button>
            )}
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Drawer
        isOpen={isDrawerOpen}
        placement="right"
        onClose={handleCloseDrawer}
        size={"full"}
      >
        <DrawerOverlay>
          <DrawerContent>
            <DrawerCloseButton />
            <DrawerHeader textAlign={"center"}>
              User Verification letter
            </DrawerHeader>
            <DrawerBody>
              <Center h={"90%"}>
                <embed
                  src={`${baseUrl}/${request?.approval_document?.name}`}
                  width="90%"
                  height="100%"
                />
              </Center>
            </DrawerBody>
          </DrawerContent>
        </DrawerOverlay>
      </Drawer>
    </Box>
  );
};

export default ApprovalRequestModal;
